const fonts = {
  family: '"roboto", Arial, san-serif',
  weight: {
    light: 400,
    regular: 500,
    medium: 700,
  },
  size: {
    smallest: '0.556rem',
    small: '0.667rem',
    main: '0.778rem',
    button: '0.778rem',
    large: '1rem',
    hExtraSmall: '1rem',
    hSmall: '1.223rem',
    hSmallDesktop: '1.778rem',
    hMedium: '1.556rem',
    hMediumDesktop: '1.778rem',
    hLarge: '2.667rem',
    hLargeDesktop: '4rem',
    bodyMain: {
      xl: "40px",
      lg: "40px",
      md: "34px",
      sm: "34px",
    },
    h1: {
      xl: "40px",
      lg: "40px",
      md: "34px",
      sm: "34px",
    },
    h2: {
      xl: "32px",
      lg: "32px",
      md: "30px",
      sm: "30px",
    },
    h3: {
      xl: "26px",
      lg: "26px",
      md: "24px",
      sm: "24px",
    },
    label: {
      xl: "10px",
      lg: "10px",
      md: "10px",
      sm: "10px",
    },
    form: {
      xl: "14px",
      lg: "14px",
      md: "16px",
      sm: "16px",
    },
    sidebar: {
      xl: "20px",
      lg: "20px",
      md: "20px",
      sm: "20px",
    },
    legal: {
      xl: "12px",
      lg: "12px",
      md: "12px",
      sm: "12px",
    }
  }
}

export { fonts as default }



// WEBPACK FOOTER //
// ./assets/common/theme/fonts.js